export default __webpack_public_path__ + "static/media/random.00ae4f92.svg";